<template>
  <div class="my-dashboard py-10 px-4">
    <div>
      <h2 class="text-lg pt-2 font-bold text-warm-gray-700">首页</h2>
      <el-divider></el-divider>
    </div>
    <p class="mt-4">欢迎您，这是您的工作台！</p>
    <p class="mt-4 mb-10">北京时间：{{ now }}</p>

    <el-alert
      type="success"
      show-icon>
      <template #title>
        <span class="text-lg font-bold text-red-400">近期更新提醒：</span>
      </template>
      <div class="mt-2 text-gray-700">
        <p class="mt-2">1. 课程中心，课时绑定资源可以在当前页面快捷上传，不需要再跳转到资源管理页面！</p>
        <p class="mt-2">2. 知识卡片页面，课时绑定资源可以在当前页面快捷上传，不需要再跳转到资源管理页面！</p>
        <p class="mt-2">3. 访问统计新增user_id, 可以统计日活/月活等基本指标（2026年6月）！</p>
      </div>
    </el-alert>

    <!-- ====================== 优化新增：三列统计卡片 ====================== -->
    <div class="grid grid-cols-1 md:grid-cols-2 gap-4 mt-8">
      <!-- 3. 浙教云访问量（新增） -->
      <el-card shadow="hover" class="transition-all">
        <div class="flex items-center gap-4">
          <div class="w-12 h-12 rounded-lg bg-purple-500 text-white flex items-center justify-center">
            <el-icon size="24"><DataAnalysis /></el-icon>
          </div>
          <div>
            <p class="text-md font-bold text-gray-500 mb-1">浙教云平台访问量PV</p>
            <p class="text-2xl font-bold text-gray-800">pv {{ zjyVisit }}</p>
          </div>
        </div>
      </el-card>
      <!-- 1. 人工智能课程 PV -->
      <el-card shadow="hover" class="transition-all">
        <div class="flex items-center gap-4">
          <div class="w-12 h-12 rounded-lg bg-blue-500 text-white flex items-center justify-center">
            <el-icon size="24"><View /></el-icon>
          </div>
          <div>
            <p class="text-md font-bold text-gray-500 mb-1">人工智能通识教育课程平台访问量PV</p>
            <p class="text-2xl font-bold text-gray-800">pv {{ aiCoursePv }}</p>
          </div>
        </div>
      </el-card>

      <!-- 2. 人工智能课程资源下载 -->
      <el-card shadow="hover" class="transition-all">
        <div class="flex items-center gap-4">
          <div class="w-12 h-12 rounded-lg bg-green-500 text-white flex items-center justify-center">
            <el-icon size="24"><Download /></el-icon>
          </div>
          <div>
            <p class="text-md font-bold text-gray-500 mb-1">人工智能通识教育课程平台资源下载次数DV</p>
            <p class="text-2xl font-bold text-gray-800">dv {{ aiDownload }}</p>
          </div>
        </div>
      </el-card>
    <!-- 4. 最新30天活跃用户数（人工智能平台）-->
      <el-card shadow="hover" class="transition-all">
        <div class="flex items-center gap-4">
          <div class="w-12 h-12 rounded-lg bg-green-500 text-white flex items-center justify-center">
            <el-icon size="24"><UserFilled /></el-icon>
          </div>
          <div>
            <p class="text-md font-bold text-gray-500 mb-1">活跃用户（最新30天登录，AI平台）</p>
            <p class="text-2xl font-bold text-gray-800">Mau {{ mauOfAiPlatform }}</p>
          </div>
        </div>
      </el-card>

      
    </div>

  </div>
</template>

<script setup lang="ts">
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
// ===== Element Plus 官方图标导入（修复图标不显示问题）=====
import { View, Download, DataAnalysis,UserFilled } from '@element-plus/icons-vue'
import CommonAccessStatisticsService from '@/apis/CommonAccessStatisticsService'
dayjs.extend(utc)
const now = dayjs().utcOffset(8).format("YYYY年MM月DD HH:mm")


// ===== 统计数据 =====
const aiCoursePv = ref<number>(1000)
const aiDownload = ref<number>(1000)
const zjyVisit = ref<number>(1000) // 浙教云访问量
const mauOfAiPlatform = ref<number>(1000) // 活跃用户数
const getZjyVisit = () => {
  CommonAccessStatisticsService.getZjyVisitPv().then(res => {
    if(res.code === 200){
      zjyVisit.value = res.data
    } else {
     console.error('获取浙教云访问量失败：' + res.msg);
    }
  }).catch(err => {
   console.log(err)
  })
}

const getAiCoursePv = () => {
  CommonAccessStatisticsService.getAiCoursePv().then(res => {
    if(res.code === 200){
      aiCoursePv.value = res.data
    } else {
     console.error('获取人工智能课程PV失败：' + res.msg);
    }
  }).catch(err => {
   console.log(err)
  })
}
const getAiDownload = () => {
  CommonAccessStatisticsService.getAiDownload().then(res => {
    if(res.code === 200){
      aiDownload.value = res.data
    } else {
     console.error('获取人工智能课程资源下载DV失败：' + res.msg);
    }
  }).catch(err => {
   console.log(err)
  })
}

const getAiPlatformMau = () => {
  CommonAccessStatisticsService.getAiPlatformMau().then(res => {
    if(res.code === 1){
      mauOfAiPlatform.value = res.data
    } else {
     console.error('获取人工智能平台活跃用户数失败：' + res.msg);
    }
  }).catch(err => {
   console.log(err)
  })
}
onMounted(() => {
  // 获取统计数据getZjyVisit
  getZjyVisit()
  // 获取人工智能课程PV
  // 获取人工智能课程资源下载DV
  getAiCoursePv()
  getAiDownload()
  // 获取最新30天活跃用户数（人工智能平台）
  getAiPlatformMau()
  

})
</script>
